export const APPROVAL_STATUS_OPTIONS = [
  { name: 'Approved', id: 'true' },
  { name: 'Approval Pending', id: 'false' },
];

export const ACTIVITY_STATUS_OPTIONS = [
  { name: 'Active', id: 'true' },
  { name: 'Inactive', id: 'false' },
];
